import BaseComponent from '../abstracts/BaseComponent';
import { match } from '../utilities/ResolutionHandler';

export default class EditorialBoxComponent extends BaseComponent {
  get SELECTORS() {
    return {
      EditorialBoxList: '#editorial-box-list',
      arrowBox: '.js-arrow-box'
    };
  }

  constructor(element) {
    super(element);
    this.handleResizeScreen();
  }

  handleResizeScreen() {
    const EditorialBoxList = this.$el.querySelector(this.SELECTORS.EditorialBoxList);
    const numberOfLi = EditorialBoxList.getElementsByTagName('li').length;
    const arrowBox = this.$el.querySelector(this.SELECTORS.arrowBox);
    if (numberOfLi) {
      this.liCounter(numberOfLi, arrowBox);
    }
    this.$on('resize.carousel', () => {
      if (numberOfLi) {
        this.liCounter(numberOfLi, arrowBox);
      }
    }, window);
  }

  liCounter(numberOfLi, arrowBox) {
    if (!arrowBox) return;
    if (match('medium', 'small')) {
      arrowBox.classList[numberOfLi > 1 ? 'remove' : 'hide']('hide');
    } else if (match('large', 'medium')) {
      arrowBox.classList[numberOfLi > 2 ? 'remove' : 'add']('hide');
    } else if (match(null, 'large')) {
      arrowBox.classList[numberOfLi > 3 ? 'remove' : 'add']('hide');
    }
  }
}
